import { Expression, NamedColumn, SqlOptions } from '../../../types';

export default function completedTasksHandler(
  column: NamedColumn, expression: Expression, sqlOptions :SqlOptions,
): Expression {
  if (sqlOptions.linkedRecords?.length) {
    return {
      ...expression,
      field: column.identifier(),
      operator: 'array_is_contained_in',
      value: sqlOptions.linkedRecords,
    };
  }
  return {
    ...expression,
    field: column.identifier(),
    operator: 'array_all_of',
    value: ['null'],
  };
}
